import { TransitData } from './TransitData';
import React from 'react';

export const Effects: React.FC<{ tabType: string; requirements: boolean }> = ({
  tabType,
  requirements,
}) => {
  return (
    <>
      <TransitData tabType={tabType} requirements={requirements} />
    </>
  );
};
